import type { Dictionary } from './en'

export const pt = {
  nav: { features: 'Recursos', pricing: 'Preço', faq: 'Perguntas', account: 'Minha conta', signIn: 'Entrar' },
  hero: {
    title: 'Alt-Tab para o seu Mac',
    tagline: 'O macOS alterna apps. O AppSwitch faz o ⌥Tab alternar janelas — todas as janelas, inclusive os três documentos abertos no mesmo app.',
    download: 'Baixar para Mac', seePricing: 'Ver preço',
    note: 'Grátis · macOS 15 ou posterior · Apple silicon e Intel',
    hint: 'Segure ⌥ e pressione Tab — solte para alternar',
  },
  features: {
    heading: 'Feito para quem mantém vinte janelas abertas',
    sub: 'Um toque em ⌥Tab mostra todas. Você solta e já chegou.',
    items: [
      { title: 'Cada janela, não cada app', body: 'O alternador do macOS troca de app. O AppSwitch troca de janela — inclusive os três documentos abertos no mesmo app.' },
      { title: 'Teclado em primeiro lugar', body: '⌥Tab para avançar, ⌥⇧Tab para voltar, setas para andar pela grade. Solte ⌥ e a janela escolhida vem para a frente.' },
      { title: 'Nunca rouba o foco', body: 'Seu app continua ativo até você escolher de fato. O AppSwitch vive na barra de menus, sem ícone no Dock atrapalhando.' },
      { title: 'Prévias ao vivo', body: 'Veja o conteúdo real de cada janela em vez de um ícone genérico. Janelas minimizadas aparecem direto no alternador.' },
    ],
  },
  pricing: {
    heading: 'Compre uma vez. É seu.',
    sub: 'O alternador é gratuito e completo — não é teste nem versão capada. O Pro acrescenta os dois recursos que precisam de licença.',
    free: 'Grátis', pro: 'Pro', ribbon: 'Compra única',
    freePrice: 'R$ 0', once: 'uma vez',
    freeSub: 'Tudo o que você precisa para largar o ⌘Tab.',
    proSub: 'Sem assinatura. Nada é renovado, nunca.',
    freeList: ['Alternador de janelas completo no ⌥Tab', 'Navegação por teclado e mouse', 'Modo grade e modo lista', 'App na barra de menus, sem ícone no Dock'],
    proList: ['Tudo da versão gratuita', 'Prévias ao vivo de cada janela', 'Janelas minimizadas no alternador', 'Dois Macs por licença'],
    download: 'Baixar', buy: 'Obter o AppSwitch Pro', buyBusy: 'Abrindo o pagamento…',
    freeFoot: 'Sem conta. Sem cartão. Sem validade.',
  },
  faq: {
    heading: 'Perguntas',
    items: [
      { q: 'Por que o AppSwitch precisa de Acessibilidade?', a: 'É a única forma de o macOS permitir que um app capture o ⌥Tab antes dos outros, liste suas janelas e traga uma para a frente. Sem isso o app simplesmente não funciona. Você concede nos Ajustes do Sistema e pode revogar quando quiser.' },
      { q: 'Isso é uma assinatura?', a: 'Não. O AppSwitch Pro é uma compra única. Nada é renovado, nada é cobrado de novo, e as atualizações da versão principal atual estão incluídas.' },
      { q: 'Em quantos Macs posso usar?', a: 'Dois por licença. Você pode liberar uma vaga a qualquer momento pela sua conta ou pelo app, então trocar de máquina nunca vira chamado de suporte.' },
      { q: 'Os títulos das minhas janelas são enviados para algum lugar?', a: 'Não. Nenhum conteúdo de janela, nenhum título e nenhuma tecla digitada sai do seu Mac. A única requisição de rede é a verificação de licença, e só se você comprou o Pro. A versão gratuita nunca acessa a rede.' },
      { q: 'Quais versões do macOS são suportadas?', a: 'macOS 15 ou posterior, em Apple silicon e Intel.' },
    ],
  },
  listMode: {
    heading: 'Duas formas de ver suas janelas',
    sub: 'A troca é feita pela barra de menus, ou com a tecla , enquanto o alternador está aberto.',
    grid: { title: 'Grade, com prévias', body: 'Miniaturas do conteúdo real. Ideal quando você reconhece uma janela pelo que ela mostra.' },
    list: { title: 'Lista, com títulos completos', body: 'Uma coluna densa em que o título inteiro de cada janela cabe numa linha. Ideal para vinte terminais, ou arquivos cujos nomes só diferem no fim.' },
  },

  footer: { terms: 'Termos de uso', privacy: 'Privacidade' },
  consent: {
    text: 'Usamos o Google Analytics para entender quais páginas são úteis. Nada é medido sem o seu consentimento. Veja nossa',
    privacyLink: 'política de privacidade', accept: 'Aceitar', decline: 'Recusar',
  },
} satisfies Dictionary
